import blogDetailPage from "@grindex-areas/Blog/Views/Pages/BlogDetailPage/xyl.views.blogDetailPage.js";
import caseStudyPage from "@grindex-areas/CaseStudies/Views/Pages/CaseStudyPage/xyl.views.caseStudyPage";
import startPage from "@grindex-areas/Core/Views/Pages/StartPage/xyl.views.startPage.js";
import singlePagePromotion from "@grindex-areas/Brand/Views/Pages/SinglePagePromotionPage/singlePagePromotion.module.js";
import productTabs from "@grindex-areas/CommerceCatalog/Views/Catalog/xyl.views.product-tabs.js";
import productSeriesTabs from "@grindex-areas/CommerceCatalog/Views/Catalog/ProductSeriesCategory/xyl.views.productSeriesTabs.js";
import advancedEventTab from "@grindex-areas/NewsEvents/Views/Components/EventAdvancedPage/js/xyl.views.advanced-event-tab.js";
import freeTextSearchPage from "@grindex-areas/Search/Views/Shared/DisplayTemplates/js/free-text-search-page.js";
import freeTextSearchTabs from "@grindex-areas/Search/Views/Shared/DisplayTemplates/js/freeTextSearchTabs.js";
import eventSearchPage from "@grindex-areas/Search/Views/Shared/DisplayTemplates/js/event-search-page.js";
import commonSearchPage from "@grindex-areas/Search/Views/Shared/DisplayTemplates/js/common-search-page.js";
import productPage from "@grindex-areas/CommerceCatalog/Views/Shared/Layouts/productPage.js";
import carouselLandingPage from "@grindex-areas/Core/Views/Pages/CarouselLandingPage/carouselLandingPage.module.js";
import productSeries from "@grindex-areas/CommerceCatalog/Views/Catalog/ProductSeriesCategory/productSeries.page.js";
import pumpProductPage from "@grindex-areas/CommerceCatalog/Views/Catalog/PumpProduct/pumpProductPage.js";
import contentDetailPage from "@grindex-areas/Core/Views/Pages/ContentDetailPage/contentDetailPage.js";
import dateFilter from "@grindex-areas/Search/Views/Shared/DisplayTemplates/js/xyl.views.dateFilter.js";

const pages = [
	blogDetailPage,
	caseStudyPage,
	startPage,
	singlePagePromotion,
	productTabs,
	productSeriesTabs,
	productSeries,
	advancedEventTab,
	freeTextSearchPage,
	freeTextSearchTabs,
	eventSearchPage,
	commonSearchPage,
	productPage,
	carouselLandingPage,
	pumpProductPage,
	contentDetailPage,
	dateFilter,
];

export { pages };
